import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/preferences';

export const getSeekerPreferencesPath = ({ nextStep } = {}) => {
  const queryparams = nextStep ? `?ns=${nextStep}` : '';

  return getRelativePath(`${BASE_PATH}${queryparams}`);
};
